import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  NO_AUTH_FORM_BUILDER_FORM_DETAILS_URL,
  NO_AUTH_FORM_BUILDER_FORM_APPLICATION_URL,
  NO_AUTH_FORM_BUILDER_FORM_AUTO_SAVE_URL,
  NO_AUTH_FORM_BUILDER_FORM_APP_SUBMIT_URL,
} from "../../Constant/api";
import { paths } from "../../Constant/paths";
import { unAuthService } from "../../Service/Axios";
import { LoadingComponent } from "../../Components/LoadingComponent";
import { toast } from "react-toastify";
import { alphanumericRegex, emailRegx, nameRegex } from "../../Utils/regex";
import Application from "../Private/FormBuilder/Application";

const GuestFormApplication = () => {
  const navigate = useNavigate();
  const { formId } = useParams();

  const [first, setfirst] = useState([]);
  const [viewForm, setviewForm] = useState();

  const [uApp, setuApp] = useState("");

  const [modalShow, setModalShow] = useState(false);

  const viewFormAction = async (data) => {
    const payload = { formId: formId, appId: data };
    const response = await unAuthService(
      NO_AUTH_FORM_BUILDER_FORM_DETAILS_URL,
      "POST",
      payload
    );
    if (response) {
      if (response.loginRequired) {
        navigate(paths.root);
      } else {
        setviewForm(response);
        let temp = [];
        response?.pages?.forEach((i) => {
          i?.sections?.forEach((el) => {
            el?.questions?.forEach((item) => {
              temp.push({
                sectionId: item?.sectionId,
                questionId: item?.questionId,
                value: item?.value,
                choiceGroupKeyValue: item?.choiceGroupKeyValue
              });
            });
          });
        });
        setfirst(temp);
      }
    }
  };

  const autoSaveForm = async (data) => {
    const payload = {
      formId: formId,
      fieldDetails: data,
      appId: uApp,
    };
    const response = await unAuthService(
      NO_AUTH_FORM_BUILDER_FORM_AUTO_SAVE_URL,
      "POST",
      payload
    );
    if (response) {
      setuApp(response.appId);
      submitApplicationForm(response.appId);
    }
  };

  useEffect(() => {
    if (first.length == 0) viewFormAction(uApp);
    // else {
    //   const delayDebounceFn = setTimeout(() => {
    //     autoSaveForm(first,uApp);
    //   }, 3000);
    //   return () => clearTimeout(delayDebounceFn);
    // }
  }, first);

  const submitApplicationForm = async (data) => {
    const payload = {
      formId: viewForm?.formId,
      formName: viewForm?.formName,
      description: viewForm?.description,
      status: "In Progress",
      pages: viewForm?.pages,
      appId: data,
    };
    const response = await unAuthService(
      NO_AUTH_FORM_BUILDER_FORM_APP_SUBMIT_URL,
      "POST",
      payload
    );
    if (response) {
    }
  };

  const saveFormApplication = async (data) => {
    const payload = {
      formId: formId,
      fieldDetails: data,
      appId: uApp,
    };
    const response = await unAuthService(
      NO_AUTH_FORM_BUILDER_FORM_APPLICATION_URL,
      "POST",
      payload
    );
    if (response) {
      if (!response.success) {
        toast.error(response.message);
      } else {
        setuApp(response.appId);
        toast.success("Form submitted.");
        setModalShow(true);
      }
      viewFormAction(response.appId);
    }
  };

  const retFind = (viewForm, item, ans) => {
    const mp = new Map();
    viewForm?.pages?.forEach((itm) =>
      itm.sections?.forEach((ele) =>
        ele.questions?.forEach((i) => mp.set(i.questionName, i.value))
      )
    );
    let flag = [];
    item?.mainConditions?.forEach((ele) => {
      if (ele.condition == "AND") {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        }
      } else if (ele.condition == "OR" && flag[flag.length - 1] == false) {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        }
      }
    });
    for (let i = 0; i < flag.length; i++) {
      if (flag[i].op == "AND") ans = ans && flag[i].val;
      else ans = ans || flag[i].val;
    }
    if (flag.length > 0) return ans;
    else return false;
  };

  const handleApplicationSave = (e) => {
    e.preventDefault();
    let unique = [],
      maxi = [],
      mini = [],
      negi = [],
      alphab = [],
      alphanum = [],
      ints = [],
      deci = [],
      beta = [],
      maxiA = [],
      miniA = [],
      maxiB = [],
      miniB = []

    let newFormView = { ...viewForm, mandatory: true };
    setviewForm(newFormView);
    newFormView?.pages?.forEach((ele) => {
      ele.sections?.forEach((i) => {
        if (i.addrule ? i.show && retFind(viewForm, i, true) : true) {
          i.questions?.forEach((item) => {
            if (
              item.addrule ? item.show && retFind(viewForm, item, true) : true
            ) {
              if (item.required) {
                if (item.typename == "emails") {
                  unique.push(
                    item.value.length > 0 && item.value[0].match(emailRegx)
                      ? item.value[0]
                      : ""
                  );
                }
                else {
                  unique.push(item.value.length > 0 ? item.value[0] : "");
                }
              }
              if (item?.validation) {
                if (item.maximumLength > 0)
                  maxi.push(
                    item.value[0]?.length <= item.maximumLength
                      ? item.value[0]
                      : ""
                  );
                if (item.minimumLength > 0)
                  mini.push(
                    item.value[0]?.length >= item.minimumLength
                      ? item.value[0]
                      : ""
                  );
                if (item.dropdownDeafultValueCheck)
                  negi.push(item.value[0] < 0 ? item.value[0] : "");
                if (item.dropdownapi == "Alphabet")
                  alphab.push(
                    nameRegex.test(item.value[0]) ? item.value[0] : ""
                  );
                if (item.dropdownapi == "Alphanumeric")
                  alphanum.push(
                    alphanumericRegex.test(item.value[0]) ? item.value[0] : ""
                  );
                if (item.numericValue == "integer")
                  ints.push(
                    Number.isInteger(Number(item.value[0])) ? item.value[0] : ""
                  );
                if (item.numericValue == "decimal")
                  deci.push(
                    !Number.isInteger(Number(item.value[0]))
                      ? item.value[0]
                      : ""
                  );
                if (item.dropdownDeafultValueCheck) {
                  beta.push(Number(item.value[0]) < 0 ? item.value[0] : "");
                }
                if (item.typename == "dates") {
                  maxiA.push(
                    new Date(item.value[0]) <= new Date(item?.numericValue[0])
                      ? item.value[0]
                      : ""
                  );
                  miniA.push(
                    new Date(item.value[0]) >= new Date(item.dropdownapi)
                      ? item.value[0]
                      : ""
                  );
                }
                if (item.typename == "times") {
                  maxiB.push(
                    item.value[0] <= item?.numericValue[0] ? item.value[0] : ""
                  );
                  miniB.push(
                    item.value[0] >= item.dropdownapi ? item.value[0] : ""
                  );
                }
              }
            }
          });
        }
      });
    });

    if (
      unique.filter((i) => i.length == 0).length < 1 &&
      maxi.filter((i) => i.length == 0).length < 1 &&
      mini.filter((i) => i.length == 0).length < 1 &&
      negi.filter((i) => i.length == 0).length < 1 &&
      alphab.filter((i) => i.length == 0).length < 1 &&
      alphanum.filter((i) => i.length == 0).length < 1 &&
      ints.filter((i) => i.length == 0).length < 1 &&
      deci.filter((i) => i.length == 0).length < 1
    ) {
      let newFormView = { ...viewForm, mandatory: false };
      setviewForm(newFormView);
      saveFormApplication(first);
    } else {
      toast.error("Please fill all required form fields to submit *");
    }
  };

  const [counter, setcounter] = useState(0);

  return (
    <LoadingComponent isLoading={false}>
      <Application
        formDetails={viewForm}
        formId={formId}
        first={first}
        setfirst={setfirst}
        handleApplicationSave={handleApplicationSave}
        setviewForm={setviewForm}
        viewForm={viewForm}
        setcounter={setcounter}
        counter={counter}
        retFind={retFind}
        modalShow={modalShow}
        setModalShow={setModalShow}
        appID={uApp}
      />
    </LoadingComponent>
  );
};

export default GuestFormApplication;
